import { createElements } from "@/Pages/Cases/functions/createElements";

export const createIFrame = ({ id, source }: { id: string; source: string }): HTMLIFrameElement | null => {
  const iframeHTML =
    "<iframe id='id::" + id + "' src='" + source + "' style='position: absolute; top: -154px;'></iframe>";

  const iframe = createElements(iframeHTML)[0];

  document.body.append(iframe);

  return iframe instanceof HTMLIFrameElement ? iframe : null;
};
